export default __webpack_public_path__ + "da787a4fba8ec467f9caf226da3115a1.jpg";